
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand-store",
      function () {
        return require("private-next-pages/brand-store.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand-store"])
      });
    }
  